import { z } from 'zod';
import { grupoSchema, isoDateSchema } from './common';

export const linhaPedidoSchema = z.object({
  'nome-abrev': z.string(),
  'nr-pedcli': z.string(),
  'nr-sequencia': z.number().int(),
  'it-codigo': z.string(),
  'descricao-item': z.string(),
  'fm-codigo': z.string(),
  subfamilia: z.string(),
  espessura: z.number(),
  largura: z.number(),
  'peso-especifico': z.number(),
  'qt-pedida': z.number(),
  'qt-pendente': z.number(),
  'dt-entrega': isoDateSchema, // data máxima de faturamento
  roteiro: z.array(grupoSchema),
  'ordens-producao': z.array(
    z.object({
      'nr-ord-produ': z.number().int(),
      'nr-linha': z.number().int(),
      estado: z.number().int().min(1).max(8), // ord-prod.estado
    }),
  ),
});
export type LinhaPedido = z.infer<typeof linhaPedidoSchema>;

/** Identificador do pedido usado em `ids-pedido`: `{nome-abrev}|{nr-pedcli}|{nr-sequencia}`. */
export const idPedido = (p: { 'nome-abrev': string; 'nr-pedcli': string; 'nr-sequencia': number }): string =>
  `${p['nome-abrev']}|${p['nr-pedcli']}|${p['nr-sequencia']}`;

export const carteiraQuerySchema = z.object({
  de: isoDateSchema.optional(),
  ate: isoDateSchema.optional(),
  'fm-codigo': z.string().optional(),
  'nome-abrev': z.string().optional(),
});
export type CarteiraQuery = z.infer<typeof carteiraQuerySchema>;
